import { render, staticRenderFns } from "./FilteredSearch.vue?vue&type=template&id=270de3d3&scoped=true"
import script from "./FilteredSearch.vue?vue&type=script&lang=ts"
export * from "./FilteredSearch.vue?vue&type=script&lang=ts"
import style0 from "./FilteredSearch.vue?vue&type=style&index=0&id=270de3d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270de3d3",
  null
  
)

export default component.exports